import request from '@/plugins/axios';
const controller = '/art/';

// 获取特别推荐
export function getSpecialArt(params) {
    return request.post(controller + 'get_special_art', params)
}

// 获取最新文章
export function getNewArts(params) {
    return request.post(controller + 'get_new_arts', params)
}

// 我的评论的文章
export function getMyCommentsArt(params) {
    return request.post(controller + 'get_my_comments_art', params)
}

// 我的评论
export function getMyArtComment(params) {
    return request.post(controller + 'get_my_art_comment', params)
}

// 我的收藏
export function collection(params) {
    return request.post(controller + 'collection', params)
}

// 取消收藏
export function delCollection(params) {
    return request.post(controller + 'del_collection', params)
}

// 获取文章列表
export function getArts(params) {
    return request.post(controller + 'get_arts', params)
}

// 获取文章详情
export function getArtInfo(params) {
    return request.post(controller + 'get_art_info', params)
}

// 获取文章类别
export function getCategorys(params) {
    return request.post(controller + 'get_categorys', params)
}

// 添加文章
export function addArt(params) {
    return request.post(controller + 'add_art', params)
}

// 编辑文章
export function editArt(params) {
    return request.post(controller + 'edit_art', params)
}

// 删除文章
export function deleteArt(params) {
    return request.post(controller + 'delete_art', params)
}

// 文章排序
export function sortChildArt(params) {
    return request.post(controller + 'sort_art', params)
}

// 监测文章类别
export function checkArtType(params) {
    return request.post(controller + 'check_art_type', params)
}